import { render, staticRenderFns } from "./ComponentHeader.vue?vue&type=template&id=54c47888"
import script from "./ComponentHeader.vue?vue&type=script&lang=js"
export * from "./ComponentHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54c47888')) {
      api.createRecord('54c47888', component.options)
    } else {
      api.reload('54c47888', component.options)
    }
    module.hot.accept("./ComponentHeader.vue?vue&type=template&id=54c47888", function () {
      api.rerender('54c47888', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/reporting/ComponentHeader.vue"
export default component.exports